import React, { FC, useCallback } from 'react';
// mui components
import { Grid, Typography } from '@mui/material';
// components
import ActionButton from 'components/buttons';
import DialogModal from 'components/modal/dialog-modal';
// hooks
import useToast from 'hooks/useToast';
// api
import {
  useDeleteFileCabinetItemMutation,
  useDeleteDefaultFolderItemMutation,
} from 'redux-store/api/file-cabinet';
// styles
import { styles } from './styles';

interface IProps {
  open: boolean;
  isFolder: boolean;
  itemId: string | number;
  fromModal: boolean;
  projectId: string | number;
  onClose: () => void;
}

const MoveToTrashModal: FC<IProps> = ({
  open,
  onClose,
  projectId,
  fromModal,
  isFolder,
  itemId,
}) => {
  const showToast = useToast();

  const subheading = `Are you sure you want to move this ${isFolder ? 'folder' : 'file'} to the Trash? You can restore it within 30 days before it’s permanently deleted.`;

  const [handleDeleteItem, { isLoading }] = useDeleteFileCabinetItemMutation();
  const [handleDeleteDefaultItem, { isLoading: defaultFolderLoading }] =
    useDeleteDefaultFolderItemMutation();

  const onConfirm = () => {
    if (fromModal) {
      handleDeleteItem({ itemId: itemId, projectId: projectId })
        .unwrap()
        .then(() => {
          onClose();
        })
        .catch(() => {
          showToast({
            message: 'Something went wrong!',
            type: 'error',
          });
        });
    }

    if (!fromModal) {
      handleDeleteDefaultItem(itemId)
        .unwrap()
        .then(() => {
          onClose();
        })
        .catch(() => {
          showToast({
            message: 'Something went wrong!',
            type: 'error',
          });
        });
    }
  };

  return (
    <DialogModal open={open} maxWidth="670px" withCloseButton={false} handleClose={onClose}>
      <Grid container sx={{ mb: '10px' }} alignItems="center">
        <Typography sx={styles.title}>Move to Trash</Typography>
      </Grid>
      <Typography sx={styles.text}>{subheading}</Typography>
      <Grid container justifyContent="flex-end" sx={{ mt: '20px' }} gap={2}>
        <ActionButton variant="secondary" onClick={onClose} label="Cancel" />
        <ActionButton
          onClick={onConfirm}
          loading={isLoading || defaultFolderLoading}
          label="Delete"
        />
      </Grid>
    </DialogModal>
  );
};
export default MoveToTrashModal;
